<template>
  <el-drawer
    title="写笔记"
    :visible.sync="visible"
    direction="btt"
    size="72%"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    @close="cancelSubmitNote(noteDrawerType)"
  >
    <div class="drawerMain-box writeNote-box">
      <p class="tips">引用内容：</p>
      <p class="quote-txt ellipsis-2"><span class="ellipsis-2">{{ selectedText }}</span></p>
      <textarea
        class="writeNote-textarea"
        placeholder="请输入您的笔记内容"
        v-model="textareaContent"
        @change="changeNoteTextarea"
      ></textarea>
      <div class="btn-box">
        <button type="submit" class="btn" @click="submitNote(noteDrawerType)">
          提交
        </button>
        <button
          type="button"
          class="btn cancel-btn"
          @click="cancelSubmitNote(noteDrawerType)"
        >
          取消
        </button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
  export default {
    name: "noteDrawer",
    props: {
      randomValue: {
        type: String,
        default: '',
      },
      //drawer 是否展示
      drawerNoteVisible: {
        type: Boolean,
        default: false,
      },
      selectedText: {
        type: String,
        default: '',
      },
      noteTextareaContent: {
        type: String,
        default: '',
      },
      noteDrawerType: {
        type: String,
        default: 'add',
      },
    },
    data() {
      return {
        visible: false,
        textareaContent: ''
      }
    },
    watch: {
      drawerNoteVisible(newVal) {
        this.visible = newVal
      },
      noteTextareaContent() {
        this.textareaContent = this.noteTextareaContent
      }
    },
    methods: {
      changeNoteTextarea() {
        this.$emit('changeNoteTextarea', this.textareaContent)
      },
      // 点击记笔记中的提交，追加笔记列表
      submitNote(type) {
        if (this.noteTextareaContent == "") {
          this.$message({
            message: "请填写内容后再提交",
            type: "error",
            duration: 2000,
            customClass: "myMessageTip", // 自定义类名
          });
        } else {
          this.$emit('submitNote', type)
        }
      },
      // 取消写笔记
      cancelSubmitNote(type) {
        this.$emit('cancelSubmitNote', type)
      },
    }
  }
</script>

<style scoped lang="scss">
/deep/.el-drawer{
  border-radius: 20rem 20rem 0 0;

  .el-drawer__header{
    padding: 0 42rem 0 32rem;
    margin: 0;
    border-bottom: 2rem solid #E3E3E3;

    span{
      font-size: 36rem;
      color: #333;
      font-weight: bold;
      line-height: 112rem;
    }

    .el-drawer__close-btn{
      font-size: 36rem;
    }
  }
}
/* 弹窗样式 start */
.drawerMain-box {
  padding: 0 24rem;
  text-align: left;
  height: 100%;
  overflow: auto;
  .block-label {
    font-size: 28rem;
    margin-bottom: 20rem;
  }
  .tips {
    font-size: 28rem;
    margin-bottom: 18rem;
    margin-top: 30rem;
    color: #313131;
  }
  .quote-txt {
    margin-bottom: 20rem;
    padding: 20rem;
    height: auto;
    font-size: 22rem;
    line-height: 30rem;
    background: #F7F7F7;
    border-radius: 6rem;
    color: #313131;
  }
  /deep/.upload-img-box {
    display: flex;
    align-items: flex-start;
    > .el-upload-list__item {
      margin: 0 8rem 8rem 0;
      width: 80rem;
      height: 80rem;
      border-radius: 6rem;
      overflow: hidden;
      border: 1rem solid #c0ccda;
      display: flex;
      img {
        width: 100%;
      }
    }
  }
  .writeNote-textarea {
    padding: 15rem;
    margin-bottom: 20rem;
    width: 100%;
    min-height: 100rem;
    height: 360rem;
    font-size: 28rem;
    font-family: unset;
    color: #2f4058;
    border-radius: 6rem;
    line-height: 42rem;
    border: 1rem solid #c1c1c1;
    -moz-user-select: auto !important; /*火狐*/
    -webkit-user-select: auto !important; /*webkit浏览器*/
    -ms-user-select: auto !important; /*IE10*/
    -khtml-user-select: auto !important; /*早期浏览器*/
    user-select: auto !important;
    list-style: auto !important;
    outline: none;
  }
  .writeNote-textarea:focus {
    border: 1px solid #0FC29A;
  }
  .btn-box {
    width: 100%;
    /*text-align: center;*/
    .btn {
      width: 300rem;
      margin: 0 auto;
      border: none;
      height: 78rem;
      font-size: 28rem;
      color: #f9f9f9;
      text-align: center;
      line-height: 78rem;
      background: #0FC29A;
      border-radius: 6rem;
      cursor: pointer;
    }
    .btn:hover {
      opacity: 0.9;
      color: #fff;
    }
    .btn.cancel-btn {
      margin-left: 30rem;
      width: 180rem;
      background: #B1B1B1;
    }
  }
}
/* 记笔记弹窗样式 end */
</style>